import { combineReducers } from "@reduxjs/toolkit";

import {
	reportSalaryReportsUsersActivityDataState,
	reportSalaryReportsUsersActivityDataReducer,
	reportSalaryReportsUsersActivityDataAction,
} from "./data";

export type StateSalaryReportsUsersActivity = {
	data: reportSalaryReportsUsersActivityDataState;
};

export const salaryReportsUsersActivity =
	combineReducers<StateSalaryReportsUsersActivity>({
		data: reportSalaryReportsUsersActivityDataReducer,
	});

export const reportsSalaryReportsUsersActivityAction = {
	data: reportSalaryReportsUsersActivityDataAction,
};

export default salaryReportsUsersActivity;
